<template>
    <div class="row">
        <div class="col-md-6 grid-margin stretch-card">

            <div class="card">

                <div class="card-body">

                    <h6 class="card-title">{{ $t('kantor_pabean') }}</h6>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('kantor_pabean') }} </label>


                        <v-select :options="fetchkodeKantor" v-model="kodeKantor" label="label" return-object
                            @input="(country) => updatekodeKantor(country)">
                            <template slot="option" slot-scope="option">
                                {{ option.label }}
                            </template>
                        </v-select>


                        <div v-if="this.kodeKantor == null">
                            <div class="alert alert-danger" style="padding:5px;"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                Kantor Pabean Kosong
                            </div>
                        </div>

                        <div v-if="errors.kodeKantor">
                            <div v-for="error in errors.kodeKantor" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('pelabuhan_tujuan') }} </label>


                        <v-select :options="fetchPelabuhanTujuan" v-model="pelabuhan_tujuan" label="KodePelabuhan"
                            return-object :filter-by="pelTujuanSearch" @input="(country) => updatePelabuhanTujuan(country)">
                            <template slot="option" slot-scope="option">
                                {{ option.KodePelabuhan + " - " + option.Pelabuhan }}
                            </template>

                            <template slot="selected-option" slot-scope="option">
                                {{ option.KodePelabuhan + " - " + option.Pelabuhan }}
                            </template>
                        </v-select>

                        <div v-if="this.pelabuhan_tujuan == null">
                            <div class="alert alert-danger" style="padding:5px;"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                Pelabuhan Tujuan Kosong
                            </div>
                        </div>

                        <div v-if="errors.kodePelTujuan">
                            <div v-for="error in errors.kodePelTujuan" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                </div>


            </div>


        </div>


        <div class="col-md-6 grid-margin stretch-card">

            <div class="card">

                <div class="card-body">

                    <h6 class="card-title">{{ $t('keterangan_lain') }}</h6>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('jenis_pib') }} </label>


                        <v-select :options="fetchkodeJenisProsedur" v-model="kodeJenisProsedur" label="label" return-object
                            @input="(country) => updatekodeJenisProsedur(country)">
                            <template slot="option" slot-scope="option">
                                {{ option.label }}
                            </template>
                        </v-select>


                        <div v-if="this.kodeJenisProsedur == null">
                            <div class="alert alert-danger" style="padding:5px;"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                Jenis PIB Kosong
                            </div>
                        </div>

                        <div v-if="errors.kodeJenisProsedur">
                            <div v-for="error in errors.kodeJenisProsedur" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('jenis_impor') }} </label>


                        <v-select :options="fetchkodeJenisImpor" v-model="kodeJenisImpor" label="label" return-object
                            @input="(country) => updatekodeJenisImpor(country)">
                            <template slot="option" slot-scope="option">
                                {{ option.label }}
                            </template>
                        </v-select>

                        <div v-if="this.kodeJenisImpor == null">
                            <div class="alert alert-danger" style="padding:5px;"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                Jenis Impor Kosong
                            </div>
                        </div>

                        <div v-if="errors.kodeJenisImpor">
                            <div v-for="error in errors.kodeJenisImpor" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('cara_pembayaran') }} </label>


                        <v-select :options="fetchkodeCaraBayar" v-model="kodeCaraBayar" label="label" return-object
                            @input="(country) => updatekodeCaraBayar(country)">
                            <template slot="option" slot-scope="option">
                                {{ option.label }}
                            </template>
                        </v-select>

                        <div v-if="this.kodeCaraBayar == null">
                            <div class="alert alert-danger" style="padding:5px;"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                Cara Pembayaran Kosong
                            </div>
                        </div>

                        <div v-if="errors.kodeCaraBayar">
                            <div v-for="error in errors.kodeCaraBayar" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                </div>

            </div>


        </div>


        <div class="col-md-12">

            <a class="nav-link" id="entitas-line-tab" data-toggle="tab" href="#entitas" role="tab" aria-controls="disabled"
                aria-selected="false">
                <button class="btn btn-info float-end btn-sm" @click="simpanHeader()" type="button" :disabled="isLoading">
                    <div v-show="isLoading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                    </div>
                    <div v-show="!isLoading">
                        <i class="link-icon mdi mdi-content-save"></i>
                        {{ $t("save_change_txt") + " " + $t('header') }}
                    </div>
                </button>
            </a>

        </div>
    </div>
</template>

<script>
export default {
    name: "CeisaHeader",
    props: {
        propsData: { type: [Object, Array] }
    },
    components: {
    },
    data() {
        return {
            isLoading:false,
            fetchPelabuhanTujuan: [],
            pelabuhan_tujuan: null,

            fetchkodeKantor: [],
            kodeKantor: null,

            fetchkodeJenisProsedur: [],
            kodeJenisProsedur: null,

            fetchkodeJenisImpor: [],
            kodeJenisImpor: null,

            fetchkodeCaraBayar: [],
            kodeCaraBayar: null,

            errors: [],
            forms: [],
            count: 0,
        }
    },
    methods: {
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 100000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },

        updatePelabuhanTujuan(data) {

            this.forms.kodePelTujuan = data.KodePelabuhan
            this.forms.namaPelTujuan = data.Pelabuhan

        },

        asyncPelabuhanTujuan() {

            this.fetchPelabuhanTujuan = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/pelabuhan?keyword=indonesia&limit=2000";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    if (response.data.datas?.message == 'Sukses') {
                        this.fetchPelabuhanTujuan = response.data.datas?.data?.result;
                    } else {
                        this.error("Something Wrong. Code : " + response.data.datas?.code);
                    }


                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        pelTujuanSearch(option, label, search) {
            let temp = search.toLowerCase();
            return option.KodePelabuhan.toLowerCase().indexOf(temp) > -1 ||
                option.Pelabuhan.toLowerCase().indexOf(temp) > -1
        },

        updatekodeKantor(data) {
            if(data){
                this.forms.kodeKantor = data.code
                this.forms.namaKantor = data.name
            }else{
                this.forms.kodeKantor = ""
                this.forms.namaKantor = ""
            }

        },

        asynckodeKantor() {

            this.fetchkodeKantor = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeKantor&status=ACTIVE&sort_field=name&sort_type=ASC&&limit=10000";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchkodeKantor.push(md);
                        }

                    }


                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });

        },


        updatekodeJenisProsedur(data) {
            if(data){
                this.forms.kodeJenisProsedur = data.code
                this.forms.namaJenisProsedur = data.name
            }else{
                this.forms.kodeJenisProsedur = ""
                this.forms.namaJenisProsedur = ""
            }

        },

        asynckodeJenisProsedur() {

            this.fetchkodeJenisProsedur = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeJenisProsedur&status=ACTIVE&sort_field=code&sort_type=ASC&limit=1000";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchkodeJenisProsedur.push(md);
                        }

                    }


                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });

        },



        updatekodeJenisImpor(data) {
            if(data){
                this.forms.kodeJenisImpor = data.code
                this.forms.namaJenisImpor = data.name
            }else{
                this.forms.kodeJenisImpor = ""
                this.forms.namaJenisImpor = ""
            }

        },

        asynckodeJenisImpor() {

            this.fetchkodeJenisImpor = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeJenisImpor&status=ACTIVE&sort_field=code&sort_type=ASC&limit=1000";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchkodeJenisImpor.push(md);
                        }

                    }



                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });

        },

        updatekodeCaraBayar(data) {
            if(data){
                this.forms.kodeCaraBayar = data.code
                this.forms.namaCaraBayar = data.name
            }else{
                this.forms.kodeCaraBayar = ""
                this.forms.namaCaraBayar = ""
            }
        },

        asynckodeCaraBayar() {

            this.fetchkodeCaraBayar = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeCaraBayar&status=ACTIVE&sort_field=code&sort_type=ASC&limit=1000";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchkodeCaraBayar.push(md);
                        }

                    }


                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });

        },
        reAssignValue() {
            if(this.forms.kodeKantor){
                this.kodeKantor = { code: this.forms.kodeKantor, name: this.forms.namaKantor, label: this.forms.kodeKantor + " - " + this.forms.namaKantor }
            }

            if(this.forms.kodePelTujuan){
                this.pelabuhan_tujuan = { KodePelabuhan: this.forms.kodePelTujuan, Pelabuhan: this.forms.namaPelTujuan, label: this.forms.kodePelTujuan + " - " + this.forms.namaPelTujuan }
            }
            if(this.forms.kodeJenisProsedur){
                this.kodeJenisProsedur = { code: this.forms.kodeJenisProsedur, name: this.forms.namaJenisProsedur, label: this.forms.kodeJenisProsedur + " - " + this.forms.namaJenisProsedur }
            }
            if(this.forms.kodeJenisImpor){
                this.kodeJenisImpor = { code: this.forms.kodeJenisImpor, name: this.forms.namaJenisImpor, label: this.forms.kodeJenisImpor + " - " + this.forms.namaJenisImpor }
            }
            if(this.forms.kodeCaraBayar){
                this.kodeCaraBayar = { code: this.forms.kodeCaraBayar, name: this.forms.namaCaraBayar, label: this.forms.kodeCaraBayar + " - " + this.forms.namaCaraBayar }
            }
            // this.pelabuhan_tujuan = { code: this.forms.kodePelTujuan, name: this.forms.namaPelTujuan, label: this.forms.kodePelTujuan + " - " + this.forms.namaPelTujuan }
        },
        simpanHeader() {
            this.isLoading = true;
            var sendData = {
                document_id: this.forms.document_id,
                kodePelTujuan: this.forms.kodePelTujuan,
                namaPelTujuan: this.forms.namaPelTujuan,
                kodeKantor: this.forms.kodeKantor,
                namaKantor: this.forms.namaKantor,
                kodeJenisProsedur: this.forms.kodeJenisProsedur,
                namaJenisProsedur: this.forms.namaJenisProsedur,
                kodeJenisImpor: this.forms.kodeJenisImpor,
                namaJenisImpor: this.forms.namaJenisImpor,
                kodeCaraBayar: this.forms.kodeCaraBayar,
                namaCaraBayar: this.forms.namaCaraBayar,
            };

            const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-2";
            this.$http.post(baseURI, sendData, { timeout: 10000 }).then((response) => {
                if (response.data.status === 200) {
                    this.loading();
                    this.errors = [];
                    this.success('Berhasil');
                    this.$emit("updateData");
                } else {
                    this.loading();
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.loading();
                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    } else {
                        this.$router.push('/page-not-found');
                    }
                }
            });
        }

    },
    watch: {
        propsData: function (newVal) {
            this.forms = newVal;
            this.reAssignValue();
        },
        forms: function (newVal) {
            this.$emit('formUpdate', newVal);
        },
    },
    created() {
        this.asyncPelabuhanTujuan();
        this.asynckodeKantor();
        this.asynckodeJenisProsedur();
        this.asynckodeJenisImpor();
        this.asynckodeCaraBayar();
    }
}
</script>

<style></style>